<template>
	<div class="playbooks-intro container">
		<!--eslint-disable vue/singleline-html-element-content-newline -->
		<div class="playbooks-intro__title">Proven Personalized Playbooks</div>
		<div class="playbooks-intro__text">
			We studied the conversion strategies of the most successful, inspiring brands in the world, then replicated
			those strategies for you in our well-designed, pre-configured Playbooks. Each Playbook below showcases the
			original source of inspiration,<br v-if="useBreaks" />
			and the proven results our customers generated through its implementation.
		</div>
		<div class="playbooks-intro__subtext">
			*If your subscription doesn't include the powerful rules used in a suggested Playbook,<br
				v-if="useBreaks"
			/>
			we'll automatically replace those rules with the best option available to you.
		</div>
	</div>
</template>
<script>
export default {
	computed: {
		/**
		 * Only break text on larger screens.
		 *
		 * @returns {boolean} True if screen width meets criteria.
		 */
		useBreaks() {
			return 1330 <= window.innerWidth;
		},
	},
};
</script>
<style lang="scss">
.playbooks-intro {
	margin: 46px auto 40px !important;
	&__title {
		font-size: 42px;
		font-weight: 700;
		line-height: 1.4em;
		margin-bottom: 13px;

		@media screen and (max-width: 720px) {
			font-size: 32px;
		}
	}
	&__text {
		font-size: 20px;
		line-height: 1.3em;
		margin-bottom: 11px;
		strong {
			font-weight: 600;
		}

		@media screen and (max-width: 720px) {
			font-size: 16px;
		}
	}
	&__subtext {
		font-size: 16px;
		line-height: 1.3em;

		@media screen and (max-width: 720px) {
			font-size: 12px;
		}
	}
}
</style>
